
import React from 'react';
import { usePortfolioHeaderSelector } from '../../../selectors/portfolioHeaderSelector';
import { usePortfolioStore } from '../../../stores/portfolioStore';
import PortfolioCommandCenter from './PortfolioCommandCenter';


export const GlobalPortfolioHeader: React.FC = () => {
  // Abonnement explicite à totalValue pour forcer le re-render après sync
  const totalValueLive = usePortfolioStore(s => s.totalValue);
    // State local pour forcer le rafraîchissement de lastSyncTime
    const [lastSync, setLastSync] = React.useState<string | undefined>(undefined);
    React.useEffect(() => {
      if (typeof window !== 'undefined') {
        setLastSync(localStorage.getItem('ecotoneai_lastSync') || undefined);
      }
    }, []);
    React.useEffect(() => {
      function updateSync() {
        if (typeof window !== 'undefined') {
          setLastSync(localStorage.getItem('ecotoneai_lastSync') || undefined);
        }
      }
      function handleStorage(e: StorageEvent) {
        if (e.key === 'ecotoneai_lastSync') updateSync();
      }
      function handleCustom() {
        updateSync();
      }
      window.addEventListener('storage', handleStorage);
      window.addEventListener('ecotoneai_lastSync_updated', handleCustom);
      updateSync();
      return () => {
        window.removeEventListener('storage', handleStorage);
        window.removeEventListener('ecotoneai_lastSync_updated', handleCustom);
      };
    }, []);
  const {
    totalValue,
    totalAssets,
    connectedExchanges,
    btcDominance,
    change24hValue,
    change24hPercent,
    lastSyncTime
  } = usePortfolioHeaderSelector();
  // Pour la démo, valeurs mockées ou issues du store (à adapter selon backend)
  // TODO: Remplacer les valeurs mockées par les vraies du backend/store si dispo
  const portfolioScore = 0.42; // À remplacer par la vraie valeur
  const stablecoinExposure = 0.0; // À remplacer par la vraie valeur
  const marketRegime = 'BTC_DOMINANCE'; // À remplacer par la vraie valeur
  const portfolioAlignment = 0.85; // À remplacer par la vraie valeur
  const effectiveTotalValue = typeof totalValue === 'number' && (totalValue > 0 || totalAssets === 0)
    ? totalValue
    : totalValueLive;

  const data = {
    totalValue: effectiveTotalValue,
    change24h: change24hValue,
    change24hPercent: change24hPercent,
    btcDominance: btcDominance / 100, // attendu entre 0 et 1
    assetCount: totalAssets,
    exchangeCount: connectedExchanges,
    stablecoinExposure,
    portfolioScore,
    marketRegime,
    portfolioAlignment,
    lastSync: lastSync || lastSyncTime || ''
  };
  // Utilise PortfolioCommandCenter pour l'affichage principal
  return <PortfolioCommandCenter data={data} />;
};

export default GlobalPortfolioHeader;
